/**
 * Subtle pupil tracking — pupils translate toward cursor with lerp smoothing.
 * Movement clamped small for non-aggressive feel.
 */
export default function initEyeTrack() {
    const pupils = document.querySelectorAll('.onk-pupil-rect');
    if (!pupils.length) return;

    const MAX_TRAVEL = 14;       // svg-unit max offset
    const LERP = 0.15;           // smoothing factor (smaller = smoother/slower)
    let targetX = 0, targetY = 0;
    let curX = 0, curY = 0;
    let rafId = null;

    function onMove(e) {
        const w = window.innerWidth;
        const h = window.innerHeight;
        const nx = (e.clientX / w) * 2 - 1;
        const ny = (e.clientY / h) * 2 - 1;
        targetX = Math.max(-1, Math.min(1, nx)) * MAX_TRAVEL;
        targetY = Math.max(-1, Math.min(1, ny)) * MAX_TRAVEL;
        if (rafId === null) rafId = requestAnimationFrame(tick);
    }

    function tick() {
        curX += (targetX - curX) * LERP;
        curY += (targetY - curY) * LERP;
        const tStr = `translate(${curX.toFixed(2)} ${curY.toFixed(2)})`;
        pupils.forEach(p => p.setAttribute('transform', tStr));
        if (Math.abs(targetX - curX) > 0.05 || Math.abs(targetY - curY) > 0.05) {
            rafId = requestAnimationFrame(tick);
        } else {
            curX = targetX;
            curY = targetY;
            rafId = null;
        }
    }

    window.addEventListener('mousemove', onMove, { passive: true });
}
